import { DebugAction } from '../types'
import { Bug, MessageSquare, FileText } from 'lucide-react'
export function jiraAction(config: {
  createIssue: (log: any) => Promise<void>
  label?: string
}): DebugAction {
  return {
    id: 'jira',
    label: config.label || 'Crear Bug en Jira',
    icon: Bug,
    color: 'text-blue-400',
    bgColor: 'bg-blue-500/10',
    hoverBgColor: 'hover:bg-blue-500/20',
    handler: async (log) => {
      await config.createIssue(log)
    },
  }
}
export function slackAction(config: {
  sendMessage: (log: any) => Promise<void>
  label?: string
}): DebugAction {
  return {
    id: 'slack',
    label: config.label || 'Enviar a Slack',
    icon: MessageSquare,
    color: 'text-purple-400',
    bgColor: 'bg-purple-500/10',
    hoverBgColor: 'hover:bg-purple-500/20',
    handler: async (log) => {
      await config.sendMessage(log)
    },
  }
}
export function confluenceAction(
  config: {
    onCopy?: () => void
    label?: string
  } = {},
): DebugAction {
  return {
    id: 'confluence',
    label: config.label || 'Copiar para Confluence',
    icon: FileText,
    color: 'text-blue-400',
    bgColor: 'bg-blue-500/10',
    hoverBgColor: 'hover:bg-blue-500/20',
    handler: async (log) => {
      const markup = `h2. API Error: ${log.tool}\n\n*Source:* ${log.source}\n*Timestamp:* ${new Date(log.timestamp).toLocaleString()}\n\n{code:json|title=Request}\n${JSON.stringify(log.params, null, 2)}\n{code}\n\n{code:json|title=Response}\n${JSON.stringify(log.rawResponse || log.error, null, 2)}\n{code}`
      await navigator.clipboard.writeText(markup)
      config.onCopy?.()
    },
  }
}
